import { ReactNode } from 'react';
import { Modal } from 'antd';
import Button from '../Button';
import CloseIcon from '../icons/CloseIcon';
import Subtitle from '../Subtitle';
import { useWidth } from '../../../lib/useWidth';
import ModalFeedbackView from '../feedback/ModalFeedbackView';
import { useSelector } from 'react-redux';
import { selectLang } from '../../../store/ui/ui.selector';
import { translate } from '../../../lib/lang.helper';

interface Props {
  type: string;
  onCancel: () => void;
  onConfirm: () => void;
  className?: string;
  children: ReactNode;
  hideCancelBtn?: boolean;
  title: string;
  visible: boolean;
  disabled?: boolean;
  confirmNameBtn?: string | undefined;
  modalWidth?: number | undefined;
}

const InputModal = ({
  visible,
  onCancel,
  onConfirm,
  hideCancelBtn,
  title,
  children,
  type,
  disabled,
  className,
  confirmNameBtn,
  modalWidth,
}: Props) => {
  const width = useWidth();
  const lang = useSelector(selectLang);

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      className={className}
      footer={null}
      closable
      closeIcon={<CloseIcon />}
      width={modalWidth !== undefined ? modalWidth : 600}
    >
      <ModalFeedbackView />
      <div className='wrap'>
        <div className='d-flex align-center mb-16'>
          <Subtitle color='black-1' align='left' size={1} fontWeight={600}>
            {translate(lang, title)}
          </Subtitle>
        </div>
        {children}
      </div>
      <div className='modal-button d-flex justify-end align-center'>
        {hideCancelBtn && (
          <Button
            width={width < 769 ? 'wide' : 'small'}
            size={2}
            type='transparent'
            color='blue'
            onClick={onCancel}
          >
            {translate(lang, 'Cancel')}
          </Button>
        )}
        {type === 'confirm' && (
          <Button
            width={width < 769 ? 'wide' : 'small'}
            size={2}
            type='fill'
            color='green'
            className='ml-16'
            onClick={onConfirm}
            disabled={disabled}
          >
            {confirmNameBtn || <>{translate(lang, 'Confirm')}</>}
          </Button>
        )}
        {type === 'create' && (
          <Button
            width={width < 769 ? 'wide' : 'small'}
            size={2}
            type='fill'
            color='green'
            className='ml-16'
            onClick={onConfirm}
            disabled={disabled}
          >
            {translate(lang, 'Create')}
          </Button>
        )}
        {type === 'close' && (
          <Button
            width={width < 769 ? 'wide' : 'small'}
            size={2}
            type='fill'
            color='green'
            className='ml-16'
            onClick={onConfirm}
            disabled={disabled}
          >
            {translate(lang, 'Close')}
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default InputModal;
